export const ManualsData = [
  {
    id: 1,
    title:
      "Federal Government Demand for Grants on Pakistan Post Office for 2022-23",
    url: "https://pakpost.gov.pk/pdfForms/2023-08-28-Budget-Book-2022-23-Composed-Copy.pdf",
    title2: "Pakistan Postal Services Management Board Ordinance, 2002",
    url2: "https://pakpost.gov.pk/pdfForms/25-04-2020-Pakistan-Postal-Services-Management-Board-Ordinance-2002.pdf",
  },
  {
    id: 2,
    title: "Director General's Special Circular Dated 27-04-2023",
    url: "https://pakpost.gov.pk/pdfForms/2023-06-20-Director-General-Special-Circular-27-4-2023-under-the-DGPPO-IBD.pdf",
    title2: "Director General Circular No.7/2020 Dated 15-06-2020",
    url2: "https://pakpost.gov.pk/pdfForms/2023-06-16-Director-General-Circular-No-72020-under-the-DGPPO-IBD.pdf",
    title3: "Director General Circular No.9/2020 Dated 15-07-2020",
    url3: "https://pakpost.gov.pk/pdfForms/2023-04-17-Director-General-Circular-No-92020-under-the-DGPPO-IBD.pdf",
    title4: "Director General Circular No.4/2021 Dated 15-04-2021",
    url4: "https://pakpost.gov.pk/pdfForms/2023-03-22-Director-General-Circular-No-42021-under-the-DGPPO-IBD.pdf",
    title5: "Director General Circular No.8/2020 Dated 15-07-2020",
    url5: "https://pakpost.gov.pk/pdfForms/2023-03-20-Director-General-Circular-No-82020-under-the-DGPPO-IBD.pdf",
  },
  {
    id: 3,
    title: "Post Office Manual Volume - I",
    url: "https://drive.google.com/uc?export=download&id=1Jx_wmSxUd15wdNdtyWzSY11XmkCjornG",
    title2: "Post Office Manual Volume - II (FILE-01)",
    url2: "https://drive.google.com/uc?export=download&id=1wxHINIOsBxdJwCEK7zP3ov75r24eF1X_",
    title3: "Post Office Manual Volume - II (FILE-01)",
    url3: "https://drive.google.com/uc?export=download&id=1WkvQCEmHa3Lr3b0bWbp6yU3tlPQr0VZ0",
    title4: "Post Office Manual Volume - II (FILE-01)",
    url4: "https://drive.google.com/uc?export=download&id=1CrGgxKHvhLJnIay8MoJ3S_RZPqrcfEok",
    title5: "Post Office Manual Volume - III",
    url5: "https://drive.google.com/uc?export=download&id=1H1iXyYNwpOXgp6b_zoSMxp9g1T9YOanc",
    title6: "Post Office Manual Volume - IV",
    url6: "https://drive.google.com/uc?export=download&id=1y0dG8HxUPfPk43IPirjEioA3AWA2bUvd",
    title7: "Post Office Manual Volume - V",
    url7: "https://drive.google.com/uc?export=download&id=1y4gQVO3N_SsK2PTkJRr51OlimbV0A-n6",
    title8: "Post Office Manual Volume - VI",
    url8: "https://drive.google.com/uc?export=download&id=1kMbKpqe_X1-_1TFySsCJCzH0Tj-vt9RU",
    title9: "Post Office Manual Volume - VII",
    url9: "https://drive.google.com/uc?export=download&id=1Pfbm3kN4n97yQbmldwdBaCp45oLmy-mO",
    title10: "Post Office Manual Volume - VIII",
    url10:
      "https://drive.google.com/uc?export=download&id=1Bz3Thvl4TlqzWq7EtxbH9e_45ptjIh08",
    title11: "Post Office Manual Volume - IX",
    url11:
      "https://drive.google.com/uc?export=download&id=1M45OTQX2if9pmaOQmXEVl936FtoN9WaS",
  },
  {
    id: 4,
    title:
      "Amendment in Statutory Rules and Regulations Made Under Different Legislations. Dated April 8, 2021",
    url: "https://pakpost.gov.pk/pdfForms/2021-04-19-Amendment-in-National-Savings-Schemes.pdf",
    title2:
      "Amendment in Statutory Rules and Regulations Made Under Different Legislations. Dated April 1, 2021",
    url2: "https://pakpost.gov.pk/pdfForms/2021-04-14-Amendment-in-National-Savings-Schemes.pdf",
    title3:
      "Amendment in Statutory Rules and Regulations Made Under Different Legislations. Dated February 3, 2021",
    url3: "https://pakpost.gov.pk/pdfForms/2021-02-16-Amendment-in-National-Savings-Schemes.pdf",
  },
  {
    id: 5,
    title: "Pakistan Post (AML and CFT) Regulations, 2020",
    url: "https://pakpost.gov.pk/pdfForms/2020-10-02-Gazette-(PPOD)-AML-and-CFT-Supervisory-final.pdf",
    title2:
      "Pakistan Post (AML and CFT) Supervisory Board (Powers & Functions) Rules, 2020",
    url2: "https://pakpost.gov.pk/pdfForms/2020-10-02-Notification-(PPOD)-Gazette-supervisory-board-(p&f)-rules.pdf",
    title3: "Pakistan Post (Targeted Financial Sanctions) Guidelines, 2020",
    url3: "https://pakpost.gov.pk/pdfForms/2020-10-02-Pakistan-Post-(Targeted-Financial-Sanctions)-Guidelines.pdf",
  },
  {
    id: 6,
    title:
      "Notification, Amendments in the Pakistan Post (AML & CFT) Regulations, 2020",
    url: "https://pakpost.gov.pk/pdfForms/2021-01-29-Pakistan-Post-AML-CFT-Notification.pdf",
    title2: "Cash Certificates Act, 1917",
    url2: "https://pakpost.gov.pk/pdfForms/25-04-2020-Cash-Certificates-Act-1917.pdf",
    title3: "National Savings Certificates Ordinance, 1944",
    url3: "https://pakpost.gov.pk/pdfForms/25-04-2020-National-Savings-Certificates-Ordinance-1944.pdf",
  },
  {
    id: 7,
    title: "The Government Savings Banks Act,1873",
    url: "https://pakpost.gov.pk/pdfForms/25-04-2020-The-Government-Savings-Banks-Act-1873.pdf",
    title2: "The Wireless Telegraphy Act, 1933",
    url2: "https://pakpost.gov.pk/pdfForms/25-04-2020-The-Wireless-Telegraphy-Act-1933.pdf",
  },
];
